import { Box } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ReactComponent as LogoutIcon } from 'atoms/icons/svg/sidebar/logout.svg';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SidebarMenuItem from '../item';
import SupportBtn from 'components/Support';
import './SidebarBottomMenu.scss';

type Props = {
  isExpanded: boolean;
  handleDrawerOpenClose?: () => void;
};

const SidebarBottomMenu: FC<Props> = ({
  isExpanded,
  handleDrawerOpenClose,
}) => {
  const { t } = useTranslation();

  return (
    <Box className={`menu-box ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <SupportBtn isExpanded={isExpanded} isSideBar={true} />
      <SidebarMenuItem
        name={t('Log out')}
        icon={<LogoutIcon />}
        isExpanded={isExpanded}
        onClick={() => {
          localStorage.clear();
          location.reload();
        }}
      />
      <SidebarMenuItem
        name={t('Hide menu')}
        icon={
          isExpanded ? (
            <ChevronLeftIcon className="chevron-icon" />
          ) : (
            <ChevronRightIcon className="chevron-icon" />
          )
        }
        isExpanded={isExpanded}
        onClick={handleDrawerOpenClose}
      />
    </Box>
  );
};

export default SidebarBottomMenu;
